import React from "react"
import { WingsButton } from "@wingspans-ui"
import "./AddButton.css"

/**
 * Reusable "Add" button for the portfolio section
 */
const AddButton = ({label, onClick}) => {
  return (
    <WingsButton className="add-button" variant="secondary" size="mini" iconName="plus" onClick={onClick}>
      {label}
    </WingsButton>
  )
}

export default AddButton
